import { CountryData, defaultCountries, parseCountry } from 'react-international-phone';

const getLocaleFromSlug = (slug: string[] | string | undefined): string => {
  return slug?.[1];
};

export const getCountryCodesFromSlug = (
  slug: string[] | string | undefined
): { defaultCountry: string; listCountryCodes: CountryData[] } => {
  const locale = getLocaleFromSlug(slug);
  const countryDict = {
    en: ['us'],
    'en-ca': ['ca'],
    'en-gb': ['gb'],
    'fr-ca': ['ca'],
    us: ['us'],
  };
  if (countryDict[locale] === undefined) {
    return {
      defaultCountry: 'us',
      listCountryCodes: defaultCountries,
    };
  }
  return {
    defaultCountry: countryDict[locale][0],
    listCountryCodes: filterCountries(countryDict[locale]),
  };
};

const filterCountries = (countryCodes: string[] | undefined): CountryData[] => {
  const result = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return countryCodes?.includes(iso2);
  });
  return result;
};

export const getZipCodeLengthFromSlug = (slug: string[] | string | undefined): number => {
  const locale = getLocaleFromSlug(slug);
  const zipCodeLengthDict = {
    en: 5,
    us: 5,
  };
  return zipCodeLengthDict[locale] ?? 10;
};
